import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';
import { AppHttpService } from 'src/app/core/net/http/app-http.service';

@Injectable({
  providedIn: 'root',
})
export class OnlineApplicationService extends AppHttpService {
  constructor(
    private formBuilder: FormBuilder,
    protected httpClient: HttpClient
  ) {
    super(httpClient);
  }

  getOnlineApplicationForm1() {
    return this.formBuilder.group({
      current_tenant: [null, Validators.required],
      pro_address1: [null, Validators.required],
      pro_address2: [null],
      agent_name: [null],
      agent_phone: [null],
      agent_email: [
        null,
        Validators.pattern("^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@" 
          + "[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$"),
      ],
      name: [null, Validators.required],
      surname: [null, Validators.required],
      username: [
        null,
        [
          Validators.pattern("^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@" 
          + "[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$"),
          Validators.required,
        ],
      ],
      work_phone: [null, Validators.required],
      home_phone: [null, Validators.required],
      cell_phone: [null],
      occupation: [null],
      company_name: [null],
      length_of_employment: [null],
      monthly_net_income: [null],
      other_monthly_income: [null],
      social_security_number: [null, Validators.required],
      drivers_license_number: [null, Validators.required],
      birth_date: [null, Validators.required],
      savings_account_bank: [null],
      saving_branch: [null],
      saving_account_number: [null],
      checking_account_bank: [null],
      checking_branch: [null],
      checking_account_number: [null],
      current_address1: [null, Validators.required],
      current_address2: [null],
      city: [null, Validators.required],
      state: [null, Validators.required],
      zipcode: [null, Validators.required],
      country: [null],
      howlong_at_this_address: [null],
      rent: [null],
      reason_for_moving: [null],
      owner: [null, Validators.required],
      phone: [null, Validators.required],
      emergency_contact_name: [null, Validators.required],
      emergency_contact_phone: [null, Validators.required],
      is_pet: [null,Validators.required],
      type_of_pet: [null],
      pet_description: [null],
      move_on: [null],
      prev_address1: [null],
      prev_address2: [null],
      prev_city: [null],
      prev_state: [null],
      prev_zip: [null],
      prev_country: [null],
      additional_comments: [null],
    });
  }

  getOnlineApplicationForm2() {
    return this.formBuilder.group({
      co_name: [null],
      co_surname: [null],
      co_username: [
        null,
        Validators.pattern("^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@" 
          + "[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$"),
      ],
      co_work_phone: [null],
      co_home_phone: [null],
      co_cell_phone: [null],
      co_occupation: [null],
      co_company_name: [null],
      co_length_of_employment: [null],
      co_monthly_net_income: [null],
      co_other_monthly_income: [null],
      co_social_security_number: [null],
      co_drivers_license_number: [null],
      co_birth_date: [null],
      co_savings_account_bank: [null],
      co_saving_branch: [null],
      co_saving_account_number: [null],
      co_checking_account_bank: [null],
      co_checking_branch: [null],
      co_checking_account_number: [null],
      co_current_address1: [null],
      co_current_address2: [null],
      co_city: [null],
      co_state: [null],
      co_zipcode: [null],
      co_country: [null],
      co_howlong_at_this_address: [null],
      co_rent: [null],
      co_reason_for_moving: [null],
      co_owner: [null],
      co_phone: [null],
      co_emergency_contact_name: [null],
      co_emergency_contact_phone: [null],
      co_is_pet: [null],
      co_type_of_pet: [null],
      co_pet_description: [null],
      co_move_on: [null],
      co_prev_address1: [null],
      co_prev_address2: [null],
      co_prev_city: [null],
      co_prev_state: [null],
      co_prev_zip: [null],
      co_prev_country: [null],
      co_additional_comments: [null],
    });
  }

  getOnlineApplicationForm3() {
    return this.formBuilder.group({
      total_adults: [null, Validators.required],
      total_children: [null, Validators.required],
      p1_full_name: [null],
      p1_age: [null],
      p1_relationship: [null],
      p2_full_name: [null],
      p2_age: [null],
      p2_relationship: [null],
      p3_full_name: [null],
      p3_age: [null],
      p3_relationship: [null],
      p4_full_name: [null],
      p4_age: [null],
      p4_relationship: [null],
    });
  }
  fileData:any={
    files_upload: [null],
    terms: [false, Validators.requiredTrue],
    submit_date: [null, Validators.required],
  };
  getOnlineApplicationForm4(fileData: any = this.fileData) {
    return this.formBuilder.group(fileData);
  }

  sendApplicaation(data: any) {
    return this.post('web-api/application/create', data);
  }

  getPrisignUrl(data: any) {
    return this.post('web-api/application/get-presign-url', data);
  }

  callPrisignUrl(url: string, data: any, header: any) {
    return this.put(url, data, header);
  }

  getDocumentType() {
    return this.get(`web-api/document-type/list`).pipe(
      map((response) => response)
    );
  }

  getPaypalToken(data:any){
    return this.post('web-api/payment/create', data).pipe(
      map((response) => response)
    );
  }

  getconfirmationform() {
    return this.formBuilder.group({
      name: [null, Validators.required],
      Lname: [null, Validators.required],
      Address: [null, Validators.required],
      email: [
        null,
        [
          Validators.pattern("^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@" 
          + "[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$"),
          Validators.required,
        ],
      ],
      phone: [null, Validators.required],
      city: [null, Validators.required],
      state: [null, Validators.required],
      zip: [null, Validators.required],
      is_co_applicant: [false]
    });
  }
}
